import React, { useEffect, useMemo, useState } from 'react'
import Layout from '../../components/Layout'
import DataGrid from 'react-data-grid'
import { Icon } from '@iconify/react'
import Dropdown from 'react-bootstrap/Dropdown'
import { useAppDispatch, useAppSelector } from '../../../../redux/hook'
import AddBrand from '../../components/AddBrandModal'
import { getAllBrands } from '../../slice/brandSlice'
import EditBrand from '../../components/EditBrandModal'
import DeleteBrand from '../../components/DeleteBrandModal'
import CustomPagination from '../../../../components/Pagination'
import { Search } from '../../../../components'
import { Brand, SortColumn } from '../../type'
import { getComparator } from '../../../../utils'
import { useTranslation } from 'react-i18next'
const Brands: React.FC = () => {
    const { brandList, totalCount, pageSize } = useAppSelector(
        (state) => state.brands
    )
    const { t } = useTranslation()
    const dispatch = useAppDispatch()
    const [showAddModal, setShowAddModal] = useState(false)
    const [editShowModal, setEditShowModal] = useState(false)
    const [seletedBrand, setSelectedBrand] = useState<Brand | null>(null)
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const [currentPage, setCurrentPage] = useState<number>(1)
    const [sortColumns, setSortColumns] = useState<readonly SortColumn[]>([])
    const totalPages = Math.ceil(totalCount / pageSize)
    const [search, setSearch] = useState<string>('')
    const column = [
        {
            key: 'name',
            name: `${t('brand.tableColumns.name')}`,
            resizable: true,
            frozen: true,
            sortable: true,
        },
        {
            key: 'description',
            name: `${t('brand.tableColumns.description')}`,
            resizable: true,
            sortable: true,
        },
        {
            key: 'actions',
            name: `${t('brand.tableColumns.action')}`, // Fix the typo here
            resizable: true,
            renderCell: () => (
                <>
                    <div className="dropdown-custom-link">
                        <Icon
                            onClick={() => {
                                setEditShowModal(true)
                            }}
                            icon="bx:edit"
                            className="icon-primary"
                        />
                        <Icon
                            onClick={() => {
                                setShowDeleteModal(true)
                            }}
                            icon="icon-park-outline:delete"
                            className="icon-secondary"
                        />
                        <Dropdown>
                            <Dropdown.Toggle
                                variant="success"
                                id="dropdown-basic"
                            >
                                <Icon icon="mage:dots" />
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item href="#/action-1">
                                    {t(
                                        'brand.tableColumns.actions.changePassword'
                                    )}
                                </Dropdown.Item>
                                <Dropdown.Item href="#/action-2">
                                    {t(
                                        'brand.tableColumns.actions.resetPassword'
                                    )}
                                </Dropdown.Item>
                                <Dropdown.Item href="#/action-3">
                                    {t('brand.tableColumns.actions.deactivate')}
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </>
            ),
        },
    ]

    useEffect(() => {
        dispatch(
            getAllBrands({
                search: search,
                currentPage: currentPage,
                recordsPerpage: 5,
            })
        )
    }, [dispatch, currentPage, search])

    const getCurrentPage = (page: number) => {
        setCurrentPage(page)
    }

    const getValue = (value: string) => {
        setSearch(value)
    }

    const sortedRows = useMemo(() => {
        if (sortColumns.length === 0) return brandList

        return [...brandList].sort((a: Brand, b: Brand) => {
            for (const sort of sortColumns) {
                const comparator: any = getComparator(sort.columnKey)
                const compResult = comparator(a, b)
                if (compResult !== 0) {
                    return sort.direction === 'ASC' ? compResult : -compResult
                }
            }
            return 0
        })
    }, [brandList, sortColumns])

    return (
        <div>
            <AddBrand show={showAddModal} onClose={setShowAddModal} />
            <EditBrand
                show={editShowModal}
                onClose={setEditShowModal}
                data={seletedBrand || { name: '', description: '', id: '' }}
            />
            <DeleteBrand
                show={showDeleteModal}
                onClose={setShowDeleteModal}
                data={seletedBrand || { name: '', description: '', id: '' }}
            />

            <Layout>
                <div className="col-12 grid-custom-table">
                    <div className="page-information mb-3">
                        <div className="row">
                            <div className="col-sm-6">
                                <h4>{t('brand.title')}</h4>
                            </div>
                            <div className="col-sm-6">
                                <div className="custom-btn-design">
                                    <a
                                        onClick={() => {
                                            setShowAddModal(true)
                                        }}
                                        className="button button-primary button-align-right"
                                    >
                                        {t('button.addBrand')}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <Search placeholder="Search" onSearch={getValue} />
                    </div>
                    {brandList && (
                        <>
                            <DataGrid
                                className="data-grid-table"
                                columns={column}
                                rowKeyGetter={(row: Brand) => row.id}
                                rows={sortedRows}
                                onCellClick={(row) => {
                                    setSelectedBrand(row.row)
                                }}
                                sortColumns={sortColumns}
                                onSortColumnsChange={setSortColumns}
                            />
                        </>
                    )}
                    {brandList.length >= 1 && (
                        <CustomPagination
                            totalPages={totalPages}
                            currentPage={currentPage}
                            getPageNumber={getCurrentPage}
                        />
                    )}
                </div>
            </Layout>
        </div>
    )
}

export default Brands
